var App = App || {};

App.Buttons = (() => {
    const init = () => {
        let btns = document.querySelectorAll('.btn-primary');

        btns.forEach((btn) => {
            let onTimer;
            let offTimer;

            if (btn instanceof HTMLInputElement) {
                let button = document.createElement('button');
                button.setAttribute('type', btn.getAttribute('type'));
                button.classList.add('btn', 'btn-primary', 'btn-primary--green');
                button.innerHTML = `${btn.value}<span class="arrow">&#xFEFF;<span class="fa-regular fa-arrow-right" aria-hidden="true"></span></span>`;

                btn.after(button);
                btn.remove();
            }

            //events
            btn.addEventListener('mouseenter', (e) => {
                clearTimeout(offTimer);
                onTimer = setTimeout(() => { animateButtonIn(btn); }, 100);
            });

            btn.addEventListener('focus', (event) => {
                if (event.target.matches(':focus-visible')) {
                    // Element received focus via keyboard
                    animateButtonIn(btn);
                }
            });

            btn.addEventListener('mouseleave', (e) => {
                clearTimeout(onTimer);
                offTimer = setTimeout(() => { animateButtonOut(btn); }, 100);               
            });

            btn.addEventListener('blur', () => {
                animateButtonOut(btn);
            });
        });
    }

    const animateButtonIn = btn => {
        let arrow = btn.querySelector('.arrow');
        if (arrow) {
            let leftPosition = arrow.offsetLeft;
            let offset = window.getComputedStyle(btn).paddingRight;

            arrow.removeEventListener('transitionend', animateEnd);

            arrow.dataset.left = leftPosition;
            arrow.style.left = `calc(100% - ${offset})`;
        }
    }

    const animateButtonOut = btn => {
        let arrow = btn.querySelector('.arrow');

        if (arrow) {            
            arrow.addEventListener('transitionend', animateEnd(arrow), { once: true });

            arrow.style.left = arrow.dataset.left + 'px';
        }
    }

    const animateEnd = arrow => {
        arrow.style.left = '';
        arrow.dataset.left = '';
    }

    return {
        init: init
    }
})();

document.addEventListener('DOMContentLoaded', App.Buttons.init);
